import { render, staticRenderFns } from "./dtcSearch.vue?vue&type=template&id=4b880d30&"
import script from "./dtcSearch.vue?vue&type=script&lang=js&"
export * from "./dtcSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports